import type { ProductDisplayData } from '@eliadmin/core/src/api/products/types/product-types';
import { TrackComponent } from '@eliadmin/core/src/components/analytics/analytics-helpers';
import {
  ProductCard,
  type ProductCardProps,
} from '@eliadmin/core/src/components/product/product-card';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

export type ProductsGridProps = {
  products: ProductDisplayData[];
  priorityCount?: number;
  className?: {
    wrapper?: string;
    product?: ProductCardProps['className'];
  };
};
export function ProductsGrid(props: ProductsGridProps) {
  return (
    <div
      className={cn(
        'grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3',
        'ea-product-list',
        props.className?.wrapper,
      )}
    >
      <TrackComponent
        eventName={'view_item_list'}
        items={props.products.map(product => {
          const priceDisplay = getProductPriceDisplay(product);

          return {
            item_id: product.code,
            item_name: product.name,
            price: priceDisplay.priceOnRequest ? undefined : priceDisplay.currentWithVat,
            quantity: 1,
          };
        })}
      />
      {props.products.map((product, index) => (
        <ProductCard
          key={product.id}
          product={product}
          priority={index < (props.priorityCount ?? 0)}
          sizes="(min-width: 1280px) 270px, (min-width: 1024px) 22vw, (min-width: 768px) 30vw, (min-width: 640px) 45vw, calc(100vw - 74px)"
          className={props.className?.product}
        />
      ))}
    </div>
  );
}
